import { SpecialAttention } from '@/components/PrimaryAvailability/SpecialAttention'
import { WidgetTitle } from '@/components/WidgetTitle'
import { useWidgetSettings } from '@/hooks'
import { VStack } from '@sevenrooms/ui-kit/layout'
import type { PropsWithChildren } from 'react'

interface GroupWidgetProps {}

export function GroupWidget({ children }: PropsWithChildren<GroupWidgetProps>) {
  const { showSpecialAttentionMessage } = useWidgetSettings()

  return (
    <>
      <VStack width="100%" pt="lm" pb="lm" spacing="lm">
        <WidgetTitle />
        {showSpecialAttentionMessage && <SpecialAttention data-test="venue-special-attention" />}
      </VStack>
      {children}
    </>
  )
}
